export type FormUiStateType = any;

export * from './actionCreators';
export {mergeComponentForms} from './mergeComponentForms';
export * from './selectors';

export const convertEmailFormTargetToEmailArray = (
  emailFormTarget: string
): string[] => {
  if (!emailFormTarget || emailFormTarget === '') {
    return [];
  }
  return emailFormTarget.split(',').map((email) => email.trim());
};

export const appendEmailToEmailFormTarget = (
  emailFormTarget: string,
  newEmail: string
): string => {
  if (!newEmail || newEmail === '') {
    return emailFormTarget;
  }
  if (emailFormTarget === '') {
    return newEmail;
  }

  return `${emailFormTarget}, ${newEmail}`;
};

export const normalizeFormActionUrl = (url: string) => {
  // Handle relative paths, full URLs, and bare domains
  // Relative paths (starting with /) and full URLs are kept as-is
  // Bare domains get http:// prepended for form submission
  if (
    !url ||
    url[0] === '/' ||
    url.includes('http://') ||
    url.includes('https://')
  ) {
    return url;
  }
  return `http://${url}`;
};
